/*
 * @Description: 运营管理接口模块
 * @Author: mdb
 * @Date: 2022-11-03 15:14:25
 * @LastEditTime: 2022-11-04 09:26:07
 * @LastEditors: mdb
 */
import request from '@/utils/request'
import type { AxiosResult } from '@/typings/common'

/**
 * ************************************** 国家渠道设置 **************************************
 */
// 获取国家渠道列表数据
export function countryChannelList(data?: { paramId?: number; paramRefId?: number }) {
  return request.post<AxiosResult, AxiosResult>('/base/api/bizParamRelation/all', data)
}
// 新增/编辑国家渠道
export function countryChannelSave(data: { paramId: number; paramRefIdList: number[] }) {
  return request.post<AxiosResult, AxiosResult>('/base/api/bizParamRelation/save', data)
}
// 删除国家渠道数据
export function countryChannelDelete(data: { paramId: number }) {
  return request.post<AxiosResult, AxiosResult>('/base/api/bizParamRelation/delete', data)
}
// 根据业务参数id查询关联业务参数
export function countryChannelRelevance(data: { paramId: number }) {
  return request.post<AxiosResult, AxiosResult>('/base/api/bizParamRelation/listByParamId', data)
}
